// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"535":"9cd27e67","655":"debd794a","739":"fbcfb3f5","899":"31d6cfe0"}[chunkId] + ".chunk.css";
};